import WebApp from "@twa-dev/sdk";

export type ThemeParams = {
  bg_color?: string;
  text_color?: string;
  hint_color?: string;
  link_color?: string;
  button_color?: string;
  button_text_color?: string;
  secondary_bg_color?: string;
};

export type TgUser = {
  id: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  language_code?: string;
};

export function initTelegram(): void {
  try {
    WebApp.ready();
    WebApp.expand();
  } catch {
    // Запускаемся вне Telegram (локальный dev) — это норма.
  }
}

export function getUser(): TgUser | null {
  try {
    return WebApp.initDataUnsafe?.user ?? null;
  } catch {
    return null;
  }
}

export function getTheme(): ThemeParams {
  try {
    return (WebApp.themeParams as ThemeParams) ?? {};
  } catch {
    return {};
  }
}

export function getColorScheme(): "light" | "dark" {
  try {
    return WebApp.colorScheme;
  } catch {
    return "light";
  }
}
